<div class="dialog-container">
  <div class="header">
    <h2>Line {{ entityLine.lineId }} Warranty Claim Details</h2>
  </div>
  <div class="content">
    <table class="info-table">
      <tr>
        <td class="info-label"> Serial Number: </td>
        <td class="info-value">{{ warrantyLine()?.searchTerm }}</td>
      </tr>
      <tr>
        <td class="info-label">Defect Code: </td>
        <td class="info-value">{{ defectDescription() }}</td>
      </tr>
      <tr>
        <td class="info-label"> Warranty Notes: </td>
        <td class="info-value">{{ warrantyLine()?.notes }}</td>
      </tr>
      <tr>
        <td class="info-label"> Install Date: </td>
        <td class="info-value">{{ warrantyLine()?.installDate }}</td>
      </tr>
      <tr>
        <td class="info-label"> Failure Date: </td>
        <td class="info-value">{{ warrantyLine()?.failureDate }}</td>
      </tr>
      <tr>
        <td class="info-label"> Dealer Address: </td>
        <td class="info-value">{{ displayAddress() }}</td>
      </tr>
    </table>
  </div>
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="close()"> Close </button>
    </span>
  </div>
</div>
@if (isBusy) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}